
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { MetaTagViewer } from '@/components/admin/MetaTagViewer';
import { useAuthSession } from '@/hooks/useAuthSession';
import { toast } from 'sonner';

const MetaTagPage = () => {
  const navigate = useNavigate();
  const { session, loading } = useAuthSession();
  
  // If user is not logged in and not loading, redirect to home page
  React.useEffect(() => {
    if (!loading && !session) {
      toast.error("Bitte melden Sie sich an, um diese Seite zu sehen.");
      navigate('/');
    }
  }, [session, loading, navigate]);
  
  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-xl">Laden...</div>
      </div>
    );
  }
  
  // If no session, show placeholder until redirect happens
  if (!session) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-xl">Nicht angemeldet. Weiterleitung...</div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-slate-100">
      <div className="container mx-auto py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <Button 
              variant="outline" 
              onClick={() => navigate('/')}
            >
              Zurück zur Hauptseite
            </Button>
            
            <Button 
              variant="outline"
              onClick={() => navigate('/admin/og-image-upload')}
            >
              Zur Bildverwaltung
            </Button>
          </div>
          
          <h1 className="text-3xl font-bold mb-8">Meta-Tags Verwaltung</h1>
          
          <div className="space-y-8">
            <div className="bg-white p-6 rounded-lg shadow-md mb-8">
              <h2 className="text-xl font-semibold mb-4">
                Anleitung
              </h2>
              <p className="text-gray-700 mb-2">
                Diese Seite zeigt alle Meta-Tags der aktuellen Website an. 
                Diese Informationen werden von sozialen Medien verwendet, wenn Links zur Website geteilt werden.
              </p>
              <p className="text-gray-700 mb-2">
                Wichtige Tags sind:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 ml-4">
                <li>og:title - Der Titel für Social Media</li>
                <li>og:image - Das Vorschaubild für Social Media</li>
                <li>twitter:title - Der Titel für Twitter</li>
                <li>twitter:image - Das Vorschaubild für Twitter</li>
              </ul>
              <p className="text-gray-700">
                Die Description Tags (og:description und twitter:description) wurden entfernt, 
                damit der Text unter dem Titel auf Instagram kürzer ist.
              </p>
            </div>
            
            <MetaTagViewer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTagPage;
